import React, { useState } from 'react';
import { HStack } from '@chakra-ui/react';
import { useColors } from '../../../../components/common/Color';
import HeaderSection from '../../../../components/common/Header/HeaderSection';
import GsummaryTable from './GsummaryThree';
import { useNavigate } from 'react-router-dom';

function DayBook() {
  const colors = useColors();
  const navigate = useNavigate();  // Get the navigate function

  const handleHeaderClick = () => {
    navigate('/accounts/g_summary');  // Redirect to the Group Summary page
  };


  return (
    <div>
      {/* Use the new HeaderSection component */}
      <HeaderSection
        title="Group summary"
        breadcrumb={["Dashboard", "Accounts", "Group Summary"]}
        onClick={handleHeaderClick} // Attach the click handler
      />

      <HStack align="start" w="full"  gap="0" mt={4} p={6}>
        <GsummaryTable colors={colors} />

      </HStack>
    </div>
  );
}

export default DayBook;
